import { useEffect, useState } from 'react'

// custom hook to intercept click on links and handle windows opening
const UseLinkInterceptor = (props?: any) => {
	const { mode, iframeDocument, newApp } = props
	const [link, setLink] = useState<any>([])

	const linkHandler = () => {
		let tmp = []
		const content = document.getElementById('linkInterceptorTarget')
			? document.getElementById('linkInterceptorTarget')
			: iframeDocument || document.createElement("div")

		const anchorElements = content?.getElementsByTagName('a')

		for (var i = 0; i < anchorElements?.length; i++) {
			tmp.push({
				text: anchorElements[i].innerText,
				link: anchorElements[i].href,
			})
		}

		setLink(tmp)
	}

	useEffect(() => {
		linkHandler()
	}, [iframeDocument])

	useEffect(() => {
		const handleClick = (e) => {
			e.preventDefault()
			let linkIntercepted = e.target.href

			if (linkIntercepted == undefined) {
				for (const item of link) {
					if (e.target.innerText == item.text) {
						linkIntercepted = item.link
					}
				}
			}

			linkIntercepted = linkIntercepted.includes('https')
				? linkIntercepted
				: linkIntercepted.replace('http', 'https')

			// switch sui domini
			// utilizzare variabili d'ambiente per garantire la differenziazione tra dev/qua/prod

			// Valutare soluzione: variabile d'ambiente che fa l'elenco di quali stringhe deviare in un certo modo
			// le variabili d'ambiente saranno array di stringhe
			// (le variabili d'ambiente sono sempre stringhe ma noi la convertiamo)
			// ne serve una per i link interni all'app smartly
			// e un'altra per i link esterni a smartly ma interni a store360
			// il resto dei link saranno aperti in una nuova tab
			const smartlyHost = new URL(process.env.SMARTLY_URL).host
			const linkInterceptedHost = new URL(linkIntercepted).host
			if (
				linkIntercepted.includes(process.env.DIGITAL_PORTAL_URL) ||
				linkIntercepted.includes(process.env.STORE_360_URL) ||
				linkIntercepted.includes(process.env.WHOLESALE_URL) ||
				linkInterceptedHost.includes(smartlyHost)
			) {
				if (
					linkIntercepted.includes(
						process.env.STORE_360_URL + '/svt-console/visit'
					)
				) {
					if (mode == 'app') {
						;(
							window as any
						).webkit?.messageHandlers?.openVisitID?.postMessage(
							new URL(linkIntercepted).pathname
								.match(/[0-9]+/g)
								.toString()
						)
					} else {
						open(linkIntercepted, '_self')
					}
				} else if (
					linkIntercepted.includes(
						process.env.STORE_360_URL + '/svt-console/task'
					)
				) {
					if (mode == 'app') {
						;(
							window as any
						).webkit?.messageHandlers?.openTaskID?.postMessage(
							new URL(linkIntercepted).pathname
								.match(/[0-9]+/g)
								.toString()
						)
					} else {
						open(linkIntercepted, '_self')
					}
				} else if (
					linkIntercepted.includes(
						process.env.STORE_360_URL + '/svt-console'
					)
				) {
					if (mode == 'app') {
						;(
							window as any
						).webkit?.messageHandlers?.goToOld?.postMessage(
							'goToOld'
						)
					} else {
						open(linkIntercepted, '_self')
					}
				} else if (
					linkIntercepted.includes(
						process.env.STORE_360_URL + '/picture-mgmt'
					)
				) {
					if (mode == 'app') {
						;(
							window as any
						).webkit?.messageHandlers?.goToPm?.postMessage(
							linkIntercepted
								.replace(
									/store360.*mgmt/gm,
									process.env.PICTURE_MGM_REPLACE
								)
								.concat('/')
						)
					} else {
						open(linkIntercepted, '_self')
					}
				} else {
					open(linkIntercepted, '_self')
				}
			} else {
				const add_params = {
					target: 'out',
				}
				const url = new URL(linkIntercepted)
				const searchParams = new URLSearchParams([
					...Array.from(url.searchParams.entries()),
					...Object.entries(add_params),
				])
				const newUrl = new URL(
					`${url.origin}${url.pathname}?${searchParams}`
				)
				open(newUrl.href, '_self')
			}
		}

		const handleClickTmp = (e) => {
			e.preventDefault()
			const linkIntercepted = e.target.href

			open(linkIntercepted, '_self')
		}

		// find froala content by id
		const content = document.getElementById('linkInterceptorTarget')
			? document.getElementById('linkInterceptorTarget')
			: iframeDocument

		if (content) {
			// add event listener to each <a> element in Froala content
			let tmp = []
			const anchorElements = content.getElementsByTagName('a')
			for (var i = 0; i < anchorElements.length; i++) {
				if (mode == 'app') {
					if (newApp == 'true') {
						anchorElements[i].addEventListener('click', handleClick)
					} else {
						anchorElements[i].addEventListener(
							'click',
							handleClickTmp
						)
					}
				} else {
					anchorElements[i].addEventListener('click', handleClick)
				}
			}
		}

		return () => {
			if (content) {
				// remove event listener to each <a> element in Froala content
				const anchorElements = content.getElementsByTagName('a')
				for (var i = 0; i < anchorElements.length; i++) {
					if (mode == 'app') {
						if (newApp == 'true') {
							anchorElements[i].removeEventListener(
								'click',
								handleClick
							)
						} else {
							anchorElements[i].removeEventListener(
								'click',
								handleClickTmp
							)
						}
					} else {
						anchorElements[i].removeEventListener(
							'click',
							handleClick
						)
					}
				}
			}
		}
	}, [iframeDocument, link])

	return {
		linkHandler,
	}
}

export default UseLinkInterceptor
